import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { injectIntl, intlShape } from '../../../util/reactIntl';

import css from './SectionFeelBetter.module.css';

import ImgCalmerDays from '../../../assets/landing/feel-better-img1.png';
import ImgSleepBetter from '../../../assets/landing/feel-better-img2.png';
import ImgReconnectBody from '../../../assets/landing/feel-better-img3.png';
import ImgSupportBody from '../../../assets/landing/feel-better-img4.png';
import icon1 from '../../../assets/landing/feel-better-icon1.svg';
import icon2 from '../../../assets/landing/feel-better-icon2.svg';
import icon3 from '../../../assets/landing/feel-better-icon3.svg';
import icon4 from '../../../assets/landing/feel-better-icon4.svg';

import shape1 from '../../../assets/landing/feel-better-shape1.png';
const isRtlLocale = locale => {
  const l = (locale || '').toLowerCase();
  return l === 'ar' || l.startsWith('ar-');
};

const SectionFeelBetterComponent = props => {
  const { intl, className, rootClassName } = props;

  const locale = intl?.locale || '';
  const rtl = isRtlLocale(locale);

  const classes = classNames(rootClassName || css.root, className);

  const title = intl.formatMessage({ id: 'SectionFeelBetter.title' });

  const cards = [
    {
      key: 'calmer',
      icon: icon1,
      title: intl.formatMessage({ id: 'SectionFeelBetter.card1.title' }),
      desc: intl.formatMessage({ id: 'SectionFeelBetter.card1.desc' }),
      img: ImgCalmerDays,
      alt: intl.formatMessage({ id: 'SectionFeelBetter.card1.alt' }),
    },
    {
      key: 'sleep',
      icon: icon2,
      title: intl.formatMessage({ id: 'SectionFeelBetter.card2.title' }),
      desc: intl.formatMessage({ id: 'SectionFeelBetter.card2.desc' }),
      img: ImgSleepBetter,
      alt: intl.formatMessage({ id: 'SectionFeelBetter.card2.alt' }),
    },
    {
      key: 'reconnect',
      icon: icon3,
      title: intl.formatMessage({ id: 'SectionFeelBetter.card3.title' }),
      desc: intl.formatMessage({ id: 'SectionFeelBetter.card3.desc' }),
      img: ImgReconnectBody,
      alt: intl.formatMessage({ id: 'SectionFeelBetter.card3.alt' }),
    },
    {
      key: 'support',
      icon: icon4,
      title: intl.formatMessage({ id: 'SectionFeelBetter.card4.title' }),
      desc: intl.formatMessage({ id: 'SectionFeelBetter.card4.desc' }),
      img: ImgSupportBody,
      alt: intl.formatMessage({ id: 'SectionFeelBetter.card4.alt' }),
    },
  ];

  return (
    <section className={classes} dir={rtl ? 'rtl' : 'ltr'}>
      <span className={css.shape1}>
        <img src={shape1} alt="" />
      </span>
      <div className={css.content}>
        <h2 className={css.title} dangerouslySetInnerHTML={{ __html: title }} />

        <div className={css.grid}>
          {cards.map(c => (
            <article key={c.key} className={css.card}>
              <div className={css.cardImageWrap}>
                <img className={css.cardImage} src={c.img} alt={c.alt} loading="lazy" />
              </div>

              <div className={css.cardTop}>
                <img src={c.icon} alt="" />

                <div className={css.text}>
                  <h3 className={css.cardTitle}>{c.title}</h3>
                  <p className={css.cardDesc}>{c.desc}</p>
                </div>
              </div>

              {/* <div className={css.imageWave} aria-hidden="true">
                <svg
                  width="588"
                  height="127"
                  viewBox="0 0 588 127"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M635 0C643.836 0.000222656 651 7.16358 651 16V68.8281C606.481 88.7754 545.936 104.633 478.652 104.681C412.756 104.72 348.718 89.7164 283.995 94.4551C228.33 98.5378 185.863 116.354 132.323 123.574C89.2141 129.393 41.9319 127.48 0 120.244V16C0 7.16344 7.16344 0 16 0H635Z"
                    fill="#FDF4EC"
                  />
                </svg>
              </div> */}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

SectionFeelBetterComponent.defaultProps = {
  className: null,
  rootClassName: null,
};

SectionFeelBetterComponent.propTypes = {
  intl: intlShape.isRequired,
  className: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default injectIntl(SectionFeelBetterComponent);
